window.onscroll = function() {ScrollOffset()};

function ScrollOffset() {
    if(typeof BackTopButton !== 'undefined') {
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
            BackTopButton.style.visibility = "visible";
            BackTopButton.style.opacity = "0.7";
            BackTopButton.style.pointerEvents = "initial";
        }

        else {
            BackTopButton.style.opacity = "0";
            BackTopButton.style.pointerEvents = "none";
        }
    }
}
